import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    "selector",
    "options",
    "filterable",
    "filterable_on_mobile",
    "badge",
    "invoice",
    "status"
  ]

  connect() { this.change() }

  change() {
    const value      = this.selectorTarget.value
    const multi      = value === this.data.get("multi")
    const checkBox   = value === this.data.get("checkbox")
    const date       = value === this.data.get("date")
    const datetime   = value === this.data.get("datetime")
    const photo      = value === this.data.get("photo")
    const filterable = multi || date || datetime

    // A photo has nothing to show on an invoice.
    if (this.hasInvoiceTarget) {
      if (photo) {
        this.invoiceTarget.classList.add("d-none")
        this.invoiceTarget.querySelector('input[type="checkbox"]').checked = false
      } else {
        this.invoiceTarget.classList.remove("d-none")
      }
    }

    // A photo is taken by the technician on site: technician -> manager is the only
    // direction that means anything for this type.
    if (this.hasStatusTarget) {
      const forManager = this.data.get("statusForManager")

      Array.from(this.statusTarget.options).forEach(option => {
        if (!option.value) return

        option.disabled = photo && option.value !== forManager
      })

      if (photo) this.statusTarget.value = forManager
    }

    if (multi) {
      // Display
      this.filterableTarget.classList.remove("d-none")
      this.filterable_on_mobileTarget.classList.remove("d-none")
      this.badgeTarget.classList.remove("d-none")
      this.optionsTarget.classList.remove("d-none")

      // Enable
      this.optionsTarget.querySelector("textarea").disabled = false
    } else if (checkBox) {
      // Hide
      this.badgeTarget.classList.add("d-none")
      this.filterableTarget.classList.add("d-none")
      this.filterable_on_mobileTarget.classList.add("d-none")

      // Display
      this.optionsTarget.classList.remove("d-none")

      // Enable
      this.optionsTarget.querySelector("textarea").disabled = false
    } else {
      // Hide
      this.badgeTarget.classList.add("d-none")
      this.optionsTarget.classList.add("d-none")

      // Disable
      this.optionsTarget.querySelector("textarea").disabled = true

      // Uncheck
      this.badgeTarget.querySelector('input[type="checkbox"]').checked = false

      // Show/hide filterable based on type (mobile not supported for date filters)
      this.filterable_on_mobileTarget.classList.add("d-none")
      this.filterable_on_mobileTarget.querySelector('input[type="checkbox"]').checked = false

      if (filterable) {
        this.filterableTarget.classList.remove("d-none")
      } else {
        this.filterableTarget.classList.add("d-none")
        this.filterableTarget.querySelector('input[type="checkbox"]').checked = false
      }
    }
  }
}


